export default __webpack_public_path__ + "static/media/felix.efd34460.png";